import { useEffect, useState } from 'react';

/**
 * Womit die Leinwand malt: mit Elementen, wie bisher -- oder selbst, auf der
 * Grafikkarte (7.69).
 *
 * Wie das Thema gehört die Wahl dem Gerät, nicht dem Konto: sie ist eine
 * Frage der Leistung des Telefons, nicht des Schnitts. Deshalb im Browser
 * gespeichert. Voreinstellung ist der alte Weg, bis Saschas Telefon gesagt
 * hat, dass der neue besser ist -- und `?gl=1` an der Adresse gilt weiter,
 * zum Vergleichen.
 *
 * Die Wahl wird beim Laden gelesen und danach nicht mehr: die Vorschau baut
 * sich beim Start auf den einen oder den anderen Weg. Wer umschaltet, lädt
 * die Seite neu; der Schalter sagt das, und `setLeinwand` tut es.
 */
export type Leinwand = 'elemente' | 'grafikkarte';

export const LEINWAENDE: { id: Leinwand; label: string }[] = [
  { id: 'elemente', label: 'Wie bisher' },
  { id: 'grafikkarte', label: 'Grafikkarte' },
];

const SCHLUESSEL = 'schnitt.leinwand';

export function geleseneLeinwand(): Leinwand {
  try {
    if (localStorage.getItem(SCHLUESSEL) === 'grafikkarte') return 'grafikkarte';
  } catch {
    /* Ein Browser ohne Speicher ist kein Grund, nicht zu arbeiten. */
  }
  return 'elemente';
}

/** Ob die Leinwand in dieser Sitzung selbst malt: die Wahl, oder `?gl=1`. */
export function grafikkarteGewuenscht(): boolean {
  if (typeof window === 'undefined') return false;
  const adresse = new URLSearchParams(window.location.search).get('gl');
  if (adresse === '1') return true;
  if (adresse === '0') return false;
  return geleseneLeinwand() === 'grafikkarte';
}

const horcher = new Set<(wahl: Leinwand) => void>();

export function setLeinwand(wahl: Leinwand): void {
  try {
    localStorage.setItem(SCHLUESSEL, wahl);
  } catch {
    /* siehe oben */
  }
  for (const h of horcher) h(wahl);
}

export function useLeinwand(): Leinwand {
  const [wahl, setzen] = useState<Leinwand>(geleseneLeinwand);
  useEffect(() => {
    horcher.add(setzen);
    return () => {
      horcher.delete(setzen);
    };
  }, []);
  return wahl;
}
